<div class="services-selector-dialog">
    <span class="dialog-title">
        Seleccionar servicios
    </span>
    <span class="dialog-description">
        Estos son todos los servicios disponibles, por favor seleccione los que desee para la oficina.
    </span>
    <app-data-table
        [rows]="data.available"
        [columns]="columns"
        selectionType="multiple"
        [(selected)]="data.selected"
        (selectedChange)="onServiceSelect($event)"
        [rowId]="rowId"
        [stickyHeader]="true"
        stickyHeaderBackground="white"
        maxHeight="450px"
        overflow="auto"
    ></app-data-table>
    <div class="buttons">
        <button mat-button color="accent" class="garantor-button mini" (click)="cerrarDialogo(false)">Cancelar</button>
        <button mat-raised-button color="primary" class="garantor-button mini" (click)="cerrarDialogo(true)">Aceptar</button>
    </div>
</div>
